module.exports = __webpack_public_path__ + "img/picture_viptk05.29c73927.png";